import { withStyles, Tooltip, Box, formatAmount } from 'vopay';
import styles from './SubAccountDetails.module.scss';
import { useTranslation } from 'react-i18next';
import { Balance } from '@/hooks/useApi/useAccountBalances';
import { DetailRowsCard, BodyText } from 'UI';

const cn = withStyles(styles);

type SubAccountDetailsProps = {
  balance: Balance;
};

export default function SubAccountDetails({ balance }: SubAccountDetailsProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountBalances' });

  return (
    <DetailRowsCard
      title={t('SubAccount.title', {
        defaultValue: 'Sub-Account Information',
      })}
      details={[
        {
          label: (
            <>
              <div className={cn('subAccountDetailsInfoHeader')}>
                <BodyText weight="md" size="rg">
                  {t('SubAccount.rollUpBalance', {
                    defaultValue: 'Available Roll-Up Balance',
                  })}
                </BodyText>

                <Tooltip
                  icon="info"
                  position="right"
                  information={
                    <Box gapSize="8px" flx="col">
                      <div className={cn('tooltipTitle')}>
                        {t('SubAccount.rollUpBalance', {
                          defaultValue: 'Available Roll-Up Balance',
                        })}
                      </div>

                      <div className={cn('message')}>
                        {t('SubAccount.rollUpBalanceTooltip', {
                          defaultValue:
                            'This balance is a visual summary of all sub-accounts, calculated as the total of their balances. Funds cannot be moved from this account.',
                        })}
                      </div>
                    </Box>
                  }
                />
              </div>

              <BodyText weight="rg" size="sm" className={cn('subAccountDetailsInfoDescription')}>
                {t('SubAccount.rollUpBalanceDescription', {
                  defaultValue: 'Funds rolled up from sub-accounts. Not available for use or transfer.',
                })}
              </BodyText>
            </>
          ),
          value: `${balance.Currency} ${formatAmount(balance.RollupAvailableBalance || 0)}`,
        },
      ]}
    />
  );
}
